import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import {Record, List} from 'immutable';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import {default as Tooltip, TOOLTIP_TYPE_INLINE, TOOLTIP_POSITION_RIGHT} from 'components/Tooltip';

const NOOP = () => undefined;

export const FacetItem = Record({
  label: '',
  selected: false,
  count: '',
  tooltip: '',
  source: null,
});

const tooltipProps = {
  type: TOOLTIP_TYPE_INLINE,
  position: TOOLTIP_POSITION_RIGHT,
  noIcon: true,
  forceVisibility: false,
};

export default createReactClass({
  propTypes: {
    heading: PropTypes.string,
    onFacetSelected: PropTypes.func,
    onFacetDeselected: PropTypes.func,
    groups: ImmutablePropTypes.mapOf(
      PropTypes.shape({
        included: ImmutablePropTypes.iterable,
        available: ImmutablePropTypes.iterable,
        unavailable: ImmutablePropTypes.iterable,
      })
    ).isRequired,
  },

  getDefaultProps() {
    return {
      onFacetSelected: NOOP,
      onFacetDeselected: NOOP,
    };
  },

  selectable() {
    const {onFacetSelected, onFacetDeselected} = this.props;

    return (onFacetSelected !== NOOP) && (onFacetDeselected !== NOOP);
  },

  renderGroup(group, className = 'facets') {
    if (group.isEmpty()) {
      return null;
    }

    const groupElements = group.map((facetItem, key) => {
      const popover = (facetItem.tooltip) ? <Tooltip {...tooltipProps} content={facetItem.tooltip} /> : null;
      const handleFacetItemClicked = (event) => {
        event.preventDefault();

        if (!this.selectable()) {
          return null;
        }

        return (facetItem.selected) ? this.props.onFacetDeselected(facetItem) : this.props.onFacetSelected(facetItem);
      };
      return (
        <li onClick={handleFacetItemClicked} className={classnames({checked: facetItem.selected})} key={`facet-item-${key}`}>
          <span>{facetItem.label} {(facetItem.count) ? ' · ' : ''}{facetItem.count}</span>
          {popover}
        </li>
      );
    });

    return (
      <ul className={className}>
        {groupElements}
      </ul>
    );
  },

  render() {
    const {groups} = this.props;
    const togglable = groups.reduce((finalMemo, group) => {
      return finalMemo || group.reduce((groupMemo, facetItem) => {
        return groupMemo || facetItem.selected;
      }, false);
    }, false);
    const groupClassNames = classnames({
      selectable: this.selectable(),
      togglable,
    });
    const includedElements = this.renderGroup(
      groups.get('included', List()), classnames('facets in-kit', groupClassNames)
    );
    const availableElements = this.renderGroup(
      groups.get('available', List()), classnames('facets available', groupClassNames)
    );
    const unavailableElements = this.renderGroup(
      groups.get('unavailable', List()), classnames('facets unavailable', groupClassNames)
    );

    return (
      <div>
        <h4 className="text-sm text-upper text-muted m-xs-y-md">{this.props.heading}</h4>
        {includedElements}
        {availableElements}
        {unavailableElements}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./app/javascript/components/Facets.js